import { AppUser } from './AppAuthenticator'
import { STORAGE_KEYS } from '../AppConstants'

export function persistCurrentUser(user?: AppUser | null): void {
  if (!user) {
    localStorage.removeItem(STORAGE_KEYS.USER)
    return
  }
  localStorage.setItem(
    STORAGE_KEYS.USER,
    JSON.stringify({
      id: user.id,
      displayName: user.displayName,
      email: user.email,
      photo: user.photo,
    })
  )
}

export function loadCurrentUser(): AppUser | undefined {
  const raw = localStorage.getItem(STORAGE_KEYS.USER)
  if (!raw) return undefined
  try {
    return new AppUser(JSON.parse(raw))
  } catch {
    localStorage.removeItem(STORAGE_KEYS.USER)
    return undefined
  }
}

export function clearCurrentUser(): void {
  localStorage.removeItem(STORAGE_KEYS.USER)
}
